import {newLogger} from "../../../core/utils/logger";
import {categoriesCrop} from "./sale";
import {openPopup} from "../../../core/widgets/popup";
import * as pageComments from "../pagecomments";
import * as sidebar from "../sidebar";
import "lib/fancybox";

const logger = newLogger('Article page');

export function init(options) {
	const o = {
		page: {},
		comments: [],
		...options
	};

	logger.log('init', o);

	pageComments.init({page: o.page, comments: o.comments});
	setTimeout(sidebar.init);

	categoriesCrop($('#page_content .sale-cats'));

	openTablePopup();
}

function openTablePopup(){
	/*$('[rel="compare-table"]').click(function(){
        const template = require('./templates/compare-table.html');
        const src = $(this).attr('src');
        const content = $.tmpl(template, {src: src});
        openPopup(content, {
            cssClass: 'compare-table-popup'
        });
	})*/
    $('[rel="compare-table"]').click(function(){
        var src = $(this).attr('src');
        $.fancybox.open({
            src: src,
            baseClass: 'fancybox-custom-layout',
            thumbs: {
                hideOnClose: false
            },
            touch: {
                vertical: false
            },
            buttons: [
                'close'
            ],
            animationEffect: "fade",
            transitionEffect: false,
            clickContent: "zoom",
            clickOutside: "close"
        });
    })
}


// WEBPACK FOOTER //
// ./modules/blog/page/article.js